import { ArrowUpRight, Cpu, Globe2, Network } from "lucide-react";
import { CardMediaSlot } from "@/components/landing/CardMediaSlot";

const icons = [Globe2, Cpu, Network];

export function PhisonPartnership({ content, media = [] }) {
  return (
    <section id="phison" className="section phison-section" data-slide="08" data-testid="phison-section">
      <div className="section-heading wide">
        <p className="overline" data-testid="phison-overline">{content.overline}</p>
        <h2 data-testid="phison-title">{content.title}</h2>
        <p data-testid="phison-description">{content.description}</p>
      </div>

      <div className="phison-brief-grid" data-testid="phison-brief-grid">
        {(content.points || []).map((point, index) => {
          const Icon = icons[index] || ArrowUpRight;
          return (
            <article className="phison-card" key={point.title} data-testid={`phison-point-${index + 1}`}>
              <CardMediaSlot image={media[index]?.image} label={point.title} testId={`phison-media-${index + 1}`} className="compact-media" />
              <div className="solution-icon" data-testid={`phison-point-icon-${index + 1}`}>
                <Icon size={24} aria-hidden="true" />
              </div>
              <h3 data-testid={`phison-point-title-${index + 1}`}>{point.title}</h3>
              <p data-testid={`phison-point-text-${index + 1}`}>{point.text}</p>
            </article>
          );
        })}
      </div>

      <div className="phison-stat-strip" data-testid="phison-stat-strip">
        {(content.stats || []).map((stat, index) => (
          <span key={stat} data-testid={`phison-stat-${index + 1}`}>{stat}</span>
        ))}
      </div>
    </section>
  );
}